import { useMutation, useQueryClient } from '@tanstack/react-query';

import { PROJECT_EXPENSES_KEY } from './constants';
import { deleteProjectExpense } from './projectExpenses';

export const useDeleteProjectExpense = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => deleteProjectExpense(id),
    onSuccess: async (_, deletedId) => {
      console.debug('Deleted project expense with id:', deletedId);
      await queryClient.cancelQueries({
        queryKey: [PROJECT_EXPENSES_KEY, deletedId],
      });
      queryClient.setQueryData([PROJECT_EXPENSES_KEY, deletedId], null);

      // Invalidate the general collection (enable when we have list queries)
      // queryClient.invalidateQueries({ queryKey: [PROJECT_EXPENSES_KEY] });
    },
  });
};
